import React from 'react';

const SideBarHeader = ({ children }) => {
    return <div className='sidebar-header'>{children}</div>;
};

export default SideBarHeader;
